import React, { FC, useMemo, useState } from 'react';
import { useStaticPageQuery } from 'src/common/hooks/staticPage/useStaticPageQuery';
import { StaticPageCode, StaticPageSection } from 'src/common/models/staticPage';
import { Layout } from 'src/common/components/Layout';
import { StaticPanelLeft } from 'src/public/components/static-page/StaticPanelLeft';
import { LayoutBox } from 'src/common/components/LayoutBox';
import { StaticPageContent } from 'src/public/components/static-page/StaticPageContent';
import { useResetRedirectUrl } from 'src/common/guards/useResetRedirectUrl';

export interface StaticPageProps {
  code: StaticPageCode;
  title: string;
}

export const StaticPage: FC<StaticPageProps> = ({ code, title }) => {
  useResetRedirectUrl();

  const [activeCategory, setActiveCategory] = useState<string>();

  const { data } = useStaticPageQuery(code);

  const content = useMemo<StaticPageSection[] | undefined>(
    () =>
      data?.data.attributes.content.map((row) => ({
        content: row.content,
        id: row.id,
        title: row.heading,
      })),
    [data],
  );

  return (
    <Layout
      leftPanel={<StaticPanelLeft items={content} activeItem={activeCategory} />}
      rightPanel={null}
      title={title}
    >
      <LayoutBox tabletBackground>
        <StaticPageContent
          sections={content}
          setActiveCategory={setActiveCategory}
          staticPage={data}
        />
      </LayoutBox>
    </Layout>
  );
};
